import dayjs from 'dayjs'
import { Loading, Message } from 'element-ui'

// 全局loading实例
let loadingInstance
export default {
  install(Vue) {
    // 注入script标签
    Vue.prototype.$script = (src) => {
      return new Promise((resolve, reject) => {
        try {
          const head = document.head || document.getElementsByTagName('head')[0]
          const script = document.createElement('script')
          if (!('onload' in script)) {
            script.onreadystatechange = () => {
              if (this.readyState !== 'complete' && this.readyState !== 'loaded') {
                return
              }
              this.onreadystatechange = null
              resolve()
            }
          }
          script.onload = () => {
            this.onload = null
            resolve()
          }
          script.type = 'text/javascript'
          script.src = src
          head.appendChild(script)
        } catch (error) {
          reject(error)
        }
      })
    }

    // 防抖
    Vue.prototype.$debounce = function (func, wait, immediate) {
      let timeout
      return function () {
        const that = this
        const args = arguments
        if (timeout) {
          clearTimeout(timeout)
        }
        if (immediate) {
          const callNow = !timeout
          timeout = setTimeout(() => {
            timeout = null
          }, wait)
          if (callNow) {
            func.apply(that, args)
          }
        } else {
          timeout = setTimeout(function () {
            func.apply(that, args)
          }, wait)
        }
      }
    }

    // 节流
    Vue.prototype.$throttle = function (func, wait) {
      let timeout
      return function () {
        const that = this
        const args = arguments
        if (!timeout) {
          timeout = setTimeout(function () {
            func.apply(that, args)
            timeout = null
          }, wait)
        }
      }
    }

    // 检验表单是否通过
    Vue.prototype.$checkForm = function (formName) {
      let flag = false
      this.$refs[formName].validate((valid) => {
        flag = valid
      })
      return flag
    }

    // 格式化时间
    Vue.prototype.$fmtTime = function (time, fmt = 'YYYY-MM-DD HH:mm') {
      if (!time) { return '' }
      return dayjs(time).format(fmt)
    }

    // 整页全局loading
    Vue.prototype.$fullLoading = {
      open(text) {
        const options = {
          lock: true,
          text: text || '请稍等',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.5)'
        }
        loadingInstance = Loading.service(options)
      },
      close() {
        loadingInstance && loadingInstance.close()
      }
    }

    // 成功的提示
    Vue.prototype.$success = (msg, center = true, closeFn) => {
      Message.success({
        message: msg,
        type: 'success',
        center,
        onClose() {
          closeFn && closeFn()
        }
      })
    }

    // error的提示
    Vue.prototype.$errorToast = (msg, center = true, closeFn) => {
      Message.error({
        message: msg,
        type: 'error',
        center,
        onClose() {
          closeFn && closeFn()
        }
      })
    }

    // warning的提示
    Vue.prototype.$warning = (msg, center = true, closeFn) => {
      Message.warning({
        message: msg,
        type: 'warning',
        center,
        onClose() {
          closeFn && closeFn()
        }
      })
    }

    // 根据配置，提示错误情况
    Vue.prototype.$matchError = function (errCode, errConfig, defaultText = '系统错误') {
      if (!errCode) { return }
      const ignoreErrorCodes = [
        'system.error',
        'authorization.signin.failed',
        'authentication.failed',
        'auth failure, please sign in',
        'space.permission.denied',
      ]
      if (ignoreErrorCodes.includes(errCode)) { return }
      const text = errConfig[errCode] || defaultText
      Message.error(text)
    }

    // 传入下载地址，下载文件
    Vue.prototype.$downloadFile = function (downloadUrl) {
      if (downloadUrl) {
        const tempWin = window.open('', '_self')
        tempWin.location.href = downloadUrl
      }
    }

    // 多个文件下载
    Vue.prototype.$downloadMultipleFile = function (url, fileName) {
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.download = fileName
          document.body.appendChild(a)
          a.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        })
        .catch((error) => console.error('Error downloading the file:', error))
    }
  }
}
